import { render, staticRenderFns } from "./refund-submit.vue?vue&type=template&id=42908e47&scoped=true"
import script from "./refund-submit.vue?vue&type=script&lang=js"
export * from "./refund-submit.vue?vue&type=script&lang=js"
import style0 from "./refund-submit.vue?vue&type=style&index=0&id=42908e47&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42908e47",
  null
  
)

export default component.exports